import(/* webpackMode: "eager" */ "/home/interim/frontend/app/services/page.tsx");
